import { render, staticRenderFns } from "./baseechart.vue?vue&type=template&id=35d4cf0b&"
import script from "./baseechart.vue?vue&type=script&lang=js&"
export * from "./baseechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports